import { observer } from 'mobx-react-lite'
import { type IRowDefault, type TableStore } from 'shared/ui/TableNew'
import { UiHeaderCenterContent } from './UiHeaderCenterContent'

type IHeaderCenterContentProps<TRow extends IRowDefault> = {
  store: TableStore<TRow>
}

export const HeaderCenterContent = observer(
  <TRow extends IRowDefault>({ store }: IHeaderCenterContentProps<TRow>) => {
    const { total, element, bulkStore } = store
    const { bulkAllMode, selectedIds, changeBulkAllMode, bulkTotal } = bulkStore

    return (
      <UiHeaderCenterContent
        bulkAllMode={bulkAllMode}
        selectedIds={selectedIds}
        changeBulkAllMode={changeBulkAllMode}
        total={total}
        bulkTotal={bulkTotal}
        element={element}
      />
    )
  }
)
